<template>
    <b-button
        v-bind="$attrs"
        v-on="$listeners"
        class="btn-submit"
        type="submit"
        variant="primary"
        :disabled="loading"
        block
    >
        <b-spinner v-if="loading" variant="light" small />
        <span v-else>{{ $tc('text', pluralization) }}</span>
    </b-button>
</template>

<script>
export default {
    name: 'BtnSubmit',
    props: {
        signIn: {
            type: Boolean,
            required: false,
            default: false,
        },
        recoverPassword: {
            type: Boolean,
            required: false,
            default: false,
        },
        savePassword: {
            type: Boolean,
            required: false,
            default: false,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        pluralization() {
            if (this.signIn) return 0
            if (this.recoverPassword) return 1
            if (this.savePassword) return 2
            return 0
        },
    },
    i18n: {
        messages: {
            'en-US': {
                text: 'Sign in | Recover password | Save password',
            },
            'es-ES': {
                text: 'Iniciar sesión | Recuperar contraseña | Guardar contraseña',
            },
            'pt-BR': {
                text: 'Entrar | Recuperar a senha | Salvar senha',
            },
        },
    },
}
</script>

<style lang="scss" scoped>
button.btn-submit {
    font-size: 1.15em;
    font-weight: 700;
    background-color: #009ada;
}
</style>
